export const getTheDifferentValues = <itemsType>(
  array1: itemsType[],
  array2: itemsType[],
): itemsType[] => {
  return array1.filter((item: itemsType) => {
    return array2.indexOf(item) === -1;
  });
};
